import { Link } from "react-router-dom";
import { useLogout, useSession } from "@/api/hooks/useAuth";
import styles from "./AppShell.module.css";

/**
 * Renders the auth-state-aware trailing controls shown in AppShell's
 * topbar:
 *   - signed-out: "Sign in" link
 *   - signed-in:  display_name + "Sign out" button
 *   - loading:    nothing (avoids a flicker between "Sign in" and signed-in
 *     chrome on the first render after a hard refresh)
 *
 * Lives in its own file so AppShell.tsx stays a thin composition of slots.
 */
export function useAuthControls(): React.ReactNode {
  const session = useSession();
  const logout = useLogout();

  if (session.isPending) return null;

  const user = session.data;
  if (!user) {
    return (
      <Link to="/login" className={styles.iconBtn} aria-label="Sign in">
        Sign in
      </Link>
    );
  }

  const label = user.display_name?.trim() || user.email;
  return (
    <span className={styles.userMenu}>
      <span className={styles.userLabel} aria-label={`Signed in as ${label}`}>
        {label}
      </span>
      <button
        type="button"
        className={styles.iconBtn}
        onClick={() => logout.mutate()}
        disabled={logout.isPending}
      >
        Sign out
      </button>
    </span>
  );
}
